import React, { Fragment, useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Btn, Image, Spinner } from "../../AbstractElements";
import { Col, FormGroup, Input, Form, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsersNew, toggleUserStatus } from "../../Redux/stateSlice/allUsers";
import ViewModal from "./ViewModal";
// import EditModal from "./EditModal";
import { BASE_URL } from "../../Config/AppConstant";
import Switch from "react-switch";
import { changUserStatus, deleteUser, fetchUsers, searchUsers } from "../../Redux/stateSlice/userReducer";
import Delete from "../../CommonElements/deleteModal";

const DataTableComponent = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [viewData, setViewData] = useState("");
  const [viewModal, setViewModal] = useState(false);
  // const [editModal, setEditModal] = useState(false);
  const [search, setSearch] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const [isDelete, setIsDelete] = useState(false)
  const [deleteUserId, setDeleteUserId] = useState(null);

  const dispatch = useDispatch();

  const { loading, error, pagination, users } = useSelector(
    (state) => state.userState
  );

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(fetchUsers(currentPage, 10));
  }, [dispatch, currentPage]);

  // const EditModaltoggle = (data) => {
  //   setViewData(data);
  //   setEditModal(!editModal);
  // };

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = (id) => {
    console.log("id::",id)
    setDeleteUserId(id);
    setIsDelete(true);
  };

  const handleConfirmDelete = async () => {
    if (deleteUserId) {
      await dispatch(deleteUser(deleteUserId));
      await dispatch(fetchUsers(currentPage, 10));
      setIsDelete(false);
    }
  };

  const handleView = (data) => {
    setViewModal(true);
    setViewData(data);
  };

  // Handle status toggle with true/false
  const handleStatusToggle = async (e, id, currentStatus) => {
    const status = currentStatus === true ? false : true;

    await dispatch(changUserStatus(id, status));
    await dispatch(fetchUsers(currentPage, 10))
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(searchUsers(search));
    setIsSearch(true);
  };

  const handleClear = async () => {
    setSearch('');
    setIsSearch(false);
    dispatch(fetchUsers(currentPage, 10));
  };

  if (loading) {
    return (
      <Col className="vh-100 d-flex align-items-center justify-content-center">
        <div className="loader-box">
          <Spinner attrSpinner={{ className: "loader-5" }} />
        </div>
      </Col>
    );
  }


  if (loading) {
    return (
      <Col className="vh-100 d-flex align-items-center justify-content-center">
        <div className="loader-box">
          <Spinner attrSpinner={{ className: "loader-5" }} />
        </div>
      </Col>
    );
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  const tableColumns = [
    {
      name: "Profile",
      cell: (row) => (
        <div className="avatar">
          <Image
            attrImage={{
              body: true,
              className: "img-60 rounded-circle",
              src: `${BASE_URL}/uploads/${row?.avatar}`,
              alt: "#",
            }}
          />
        </div>
      ),
    },
    { name: "Name", selector: (row) => row.name, sortable: true, center: true },
    { name: "Email", selector: (row) => row.email, sortable: true, center: true },
    { name: "Phone", selector: (row) => row.phoneNumber, sortable: true, center: true },
    { name: "DOB", selector: (row) => row.dob, sortable: true, center: true },
    {
      name: "Status",
      cell: (row) => (

        <Switch
          onChange={(e) => handleStatusToggle(e, row?._id, row?.status)}
          checked={row?.status === true}
          offColor="#dc3545"
          onColor="#28a745"
          uncheckedIcon={false}
          checkedIcon={false}
          height={20}
          width={40}
        />
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex">
          <button className="btn btn-light p-1 mx-1" onClick={() => handleView(row)}>
            <i className="fa fa-eye" style={{ fontSize: "small", color: "#494949" }}></i>
          </button>
          {/* <button className="btn btn-light p-1 mx-1" onClick={() => EditModaltoggle(row)}>
            <i className="fa fa-edit" style={{ fontSize: "small", color: "#494949" }}></i>
          </button> */}
          <button className="btn btn-light p-1 mx-1" onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash-o" style={{ fontSize: "small", color: "#494949" }}></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <div className="d-flex gap-3">
            <Input
              type="text"
              name="name"
              id="name"
              placeholder="Search..."
              value={search}
              onChange={(e) => { setSearch(e.target.value) }}
              required
              style={{ width: "250px" }}
            />
            <Btn attrBtn={{ color: "primary" }}>Search</Btn>
            {isSearch && <Button className={{ color: "secondary" }} onClick={handleClear}>Clear</Button>}
          </div>
        </FormGroup>
      </Form>
      <DataTable
        data={users}
        columns={tableColumns}
        striped
        pagination
        paginationServer
        paginationTotalRows={pagination?.totalUsers || 0}
        onChangePage={handlePageChange}
        paginationDefaultPage={currentPage}
        selectableRows
        onSelectedRowsChange={handleRowSelected}
        clearSelectedRows={toggleDelet}
      />
      <ViewModal data={viewData} viewModal={viewModal} setViewModal={setViewModal} />
      {/* <EditModal data={viewData} editModal={editModal} setEditModal={setEditModal} /> */}
      <Delete isDelete={isDelete} setIsDelete={setIsDelete} onDelete={handleConfirmDelete} />

    </Fragment>
  );
};

export default DataTableComponent;
